import {
  Home,
  BarChart2,
  CalendarDays,
  CalendarOff,
  LayoutDashboard,
  Users,
  Building2,
  FolderTree,
  TrendingUp,
  ClipboardCheck,
  StickyNote,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface NavItem {
  id: string;
  label: string;
  icon: LucideIcon;
  href: string;
}

export interface IconRailItem {
  id: string;
  label: string;
  icon: LucideIcon;
}

export const iconRailItems: IconRailItem[] = [
  { id: 'home', icon: Home, label: 'Inicio' },
  { id: 'notes', icon: StickyNote, label: 'Notas' },
  { id: 'analytics', icon: BarChart2, label: 'Análisis' },
];

export const navItems: NavItem[] = [
  { id: 'home', label: 'Dashboard', icon: LayoutDashboard, href: 'dashboard' },
  { id: 'reports', label: 'Reportes', icon: BarChart2, href: 'reports' },
  { id: 'calendars', label: 'Calendarios', icon: CalendarDays, href: 'calendars' },
];

export const secondaryNavItems: NavItem[] = [
  { id: 'members', label: 'Miembros', icon: Users, href: 'members' },
  { id: 'clients', label: 'Clientes', icon: Building2, href: 'clients' },
  { id: 'organization-units', label: 'Organigrama', icon: FolderTree, href: 'organization-units' },
  { id: 'labor-performance', label: 'Rendimiento', icon: TrendingUp, href: 'labor-performance' },
  { id: 'forms', label: 'Formularios', icon: ClipboardCheck, href: 'forms' },
  { id: 'time-off', label: 'Ausencias', icon: CalendarOff, href: 'time-off' },
];
